import ".././styles/Constitution.css";
import React, { useMemo, useRef, useState } from "react";

import Article1 from "../components/constitution/Article1.js";
import Article2 from "../components/constitution/Article2.js";
import Article3 from "../components/constitution/Article3.js";
import Article4 from "../components/constitution/Article4.js";
import Article5 from "../components/constitution/Article5.js";
import Article6 from "../components/constitution/Article6.js";
import Article7 from "../components/constitution/Article7.js";
import Article8 from "../components/constitution/Article8.js";
import Article9 from "../components/constitution/Article9.js";
import Article10 from "../components/constitution/Article10.js";
import Article11 from "../components/constitution/Article11.js";
import Provisions from "../components/constitution/Provisions.js";

const ARTICLE_COMPONENTS = {
  1: Article1,
  2: Article2,
  3: Article3,
  4: Article4,
  5: Article5,
  6: Article6,
  7: Article7,
  8: Article8,
  9: Article9,
  10: Article10,
  11: Article11,
  12: Provisions,
};

const ARTICLES = [
  { id: 1, title: "Article I", subtitle: "Preamble" },
  { id: 2, title: "Article II", subtitle: "Definitions & Interpretations" },
  { id: 3, title: "Article III", subtitle: "Members of the Corporation" },
  { id: 4, title: "Article IV", subtitle: "Governing Board" },
  { id: 5, title: "Article V", subtitle: "Officers & Accountabilities" },
  { id: 6, title: "Article VI", subtitle: "Meetings of the Corporation" },
  { id: 7, title: "Article VII", subtitle: "Committees" },
  { id: 8, title: "Article VIII", subtitle: "Borrowing Powers" },
  { id: 9, title: "Article IX", subtitle: "Finances and Reports" },
  { id: 10, title: "Article X", subtitle: "Official Seal" },
  { id: 11, title: "Article XI", subtitle: "Amendment & Dissolution" },
  { id: 12, title: "General Provisions", subtitle: "By-Law Updates" },
];

function Constitution() {
  const [active, setActive] = useState(1);
  const viewRef = useRef(null);

  const ActiveComponent = useMemo(() => {
    return ARTICLE_COMPONENTS[active] || Article1;
  }, [active]);

  const handleSelect = (id) => {
    setActive(id);
    if (viewRef.current) {
      viewRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="constitution-page">
      <div className="page-header constitution-hero">
        <div className="overlay"></div>
        <div className="container header-content">
          <h1>Constitution & By-Laws</h1>
          <p>Our guiding principles, membership rules, and governance structure.</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="constitution-grid">
            <div className="toc-card card">
              <div className="card-content">
                <h3>Browse Articles</h3>
                <p className="text-muted">
                  Select an article to view the full text. You can switch anytime.
                </p>
                <div className="toc-list">
                  {ARTICLES.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      className={`toc-item ${active === item.id ? "active" : ""}`}
                      onClick={() => handleSelect(item.id)}
                    >
                      <span className="toc-title">{item.title}</span>
                      <span className="toc-subtitle">{item.subtitle}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="article-card card" id="constitution-active-view" ref={viewRef}>
              <div className="card-content">
                <ActiveComponent />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Constitution;
